/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { useForm } from "react-hook-form";
import { ConfigContextUtils } from '../context/contextUtils.context';
import masterFunction from '../views/master/master.functions';
//import utils from '../utils/utils.functions';
import notification from './notification.component';


const EstadosGuias = ({ onClose, datos, master, guias, show, onUpdate = null, unit = false }) => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const { register, handleSubmit, errors, reset } = useForm();
  const onSubmit = data => {
    
    let guias_ids = [datos.id];

    if (!unit) {
      guias_ids = datos.selectedRows.map((e) => e.id);
    }

    setPreloader(true);

    masterFunction.cambioEstadosMaster({
      ...data,
      ...(unit && { codigo_master: null}),
      todos_seleccionado: datos.allSelected,
      guias: guias_ids,
    }).then((respuesta) => {
      if (respuesta.resultado.cambio_estado) {
        notification.success();
        onClose();
        if (!unit) {
          onUpdate(master.id);
        }
      } else {
        notification.warning('No se realizaron cambios intentelo nuevamente');
      }
      setPreloader(false);
    })
  };

  const calculatePaquetesValidos = () => {
    if (guias === 0) {
      return 0;
    } else {
      let numeroGuias = 0;
      guias.map((e) => { 
        if (!e.guia_finalizada) {
          numeroGuias += 1;
        }});
      return numeroGuias;
    }
  }

  useEffect(() => {
    reset({
      descripcion_estado: '',
      codigo_master: master.id,
    })
  }, [show]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grupo-input">
        <small>Describa el nuevo estado para las guias</small>
        <div className="d-flex">
          <input type="text"
            className={`form-control input-border ${errors.descripcion_estado && "is-invalid"}`}
            name="descripcion_estado"
            ref={register({ required: true })}
            />
        </div>
      </div>
      {!unit && 
        <div className="d-flex mb-2">
          <div className="grupo-input mr-3">
            <small>Guias que seran afectadas</small>
            <div className="d-flex">
              {datos.allSelected ? 'Todas' : `${datos.selectedCount}/${calculatePaquetesValidos()}` }
            </div>
          </div>
          <div className="grupo-input">
            <small>Guia master seleccionada</small>
            <div className="d-flex">
              {master.text}
            </div>
          </div>
        </div>
      }
      <div style={{ color: 'red', fontSize: 12 }}>
        ¡Importante! Verifique bien la información antes de confirmar, recuerde que los clientes seran notificados del cambio del estado de su guia.
      </div>
      <div className="mt-2">
        <input type="hidden" name="codigo_master" ref={register({ required: false })} /> 
        <button onClick={onClose} type="button" className="btnx btnx-warn">Cerrar</button> {' '}
        <button type="submit" className="btnx btnx-warn">Confirmar cambio de estado</button>
      </div>
      </form>
    </div>
  )
}

export default EstadosGuias;